var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1141({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "6.79 7.14 6.79 3.13 5 3.13 8 1 11 3.13 9.21 3.13 9.21 7.14 9.21 8.86 9.21 12.87 11 12.87 8 15 5 12.87 6.79 12.87 6.79 8.86 6.79 7.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1141);
export default __webpack_public_path__ + "static/media/Symbolpack_1_141.0ca8ec8507733733f817745956940ae3.svg";
export { ForwardRef as ReactComponent };